'use strict'

let definition=require('../../definition/labels/english.js').english;

export let english={
  initiative: {
    title: "Properties",
    fields: {
      name: {
        title: "Name",
        description: "Descriptive name",
      },
      identifier: {
        title: "Identifier",
        description: "Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the initiative should be governed"
      },
      asProject: "Define New Project",
      projectCharacteristics: [
        "Driven by deliverables",
        "Finite - defined start and finish",
        "Bounded and scoped deliverables",
        "Delivery of a product",
        "Benefits usually realised after project closes",
        "Shorter Timescale"],
      asProgramme: "Define New Programme",
      programmeCharacteristics: [
        "Driven by vision of end state",
        "No pre defined path",
        "Changes to business capability",
        "Co-ordinated outputs delivery - includes projects not directly delivering benefits",
        "Benefits realised during and after the programme",
        "Longer Timescale"
      ],
      asProduct: "Define New Product",
      productCharacteristics: [
        "Manage product through its lifecycle",
        "Driven by product strategy",
        "Organize releases on roadmap",
        "Timescale is the product's lifetime"
      ]
    }
  },
  programme: {
    noProgramme: "No - Not part of a programme",
    yesProgrammePrefix: "Yes - ",
    properties: {
      title: "Programme Properties"
    },
    title:"Background",
    fields: {
      name: {
        title: "Programme Name",
        description: "Descriptive name of the programme",
      },
      identifier: {
        title: "Identifier",
        description: "Programme Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the programme should be governed"
      },
      location: {
        title: "Location",
        help: "From where is the programme managed?"
      },
      department: {
        title: "Department",
        help: "Which department or line organization owns this programme?"
      },
      background: {
        title: "Justificaton and context",
        description:"Describe the current situation, the planned improvement and how it fits into overall corporate missions and goals",
        help:`What is the current situation?
          What is the intended improvement this program will deliver?
          Which organizations are involved, and how will the organizations be improved?
          How does this programme fit into corporate missions and goals?`
      },
      timing: {
        title:"Why now?",
        description:"Justification for the timing",
        help:`What is the trigger that makes us want to do this right now?
        Any external circumstances or internal factors? Any new insight, new technology or new strategy triggering the timing of this opportunity?`
      },
      successFactors: {
        title: "Success factors",
        description:"Describe what success looks like, what the criteria are and what boundaries and constraints exists",
        help:`What are the critical success factors against which the programme will be assessed?
          Any expectations on timelines, cost, benefits or potential constraints?`
      }
    },
    actions: {
      cancel: "Cancel",
      createProgramme: "Create Programme",
      update: "Update",
      background: "background",
      project: "programme"
    }
  },
  product: {
    properties: {
      title: "Product properties"
    },
    title: "Definition",
    fields: {
      name: {
        title: "Product Name",
        description: "Descriptive name of the product",
      },
      identifier: {
        title: "Identifier",
        description: "Product Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the product should be governed"
      },
      location: {
        title: "Location",
        help: "From where is the product managed?"
      },
      department: {
        title: "Department",
        help: "Which department or line organization owns this product?"
      },
      currency: {
        title: "Currency"
      },
      description: {
        title:"Description",
        description:"Describe what type of product this is, what the product does for the users, which problems it solves, which processes it supports and how it is structured.",
        help:`What type of product is this? Is there a category name? Who is using this product and what will it do for them? Which needs does it meet or which problems does it solve? Which process areas does it cover? What is the composition of the product? Is it part of a bigger system, product line or platform? Which part of the organization is developing or maintaining it?`
      },
      background: {
        title: "Background",
        description:"Describe the history of the product and why is was introduced.",
        help:`What originally triggered the making of this product? Why was this product, and not an alternative or existing solution, preferred?`
      },
      vision: {
        title: "Vision",
        description:"Summarize a vision statement or positioning statement for this product describing the end goal.",
        help:`What is the end goal of the investment in this product – for you, the user or the customer? What will the roadmap in the end lead to? What is setting the strategic direction for the roadmap?`
      }
    },
    actions: {
      cancel: "Cancel",
      createProgramme: "Create Product",
      update: "Update",
      project: "product",
      background: "definition"
    }
  },
  release: {
    noProgramme: "No - Not part of a programme",
    yesProgrammePrefix: "Yes - ",
    properties: {
      title: "Release properties"
    },
    fields: {
      name: {
        title: "Release Name",
        description: "Descriptive name of the release",
        help: "Updated as part of the release plan"
      },
      identifier: {
        title: "Identifier",
        description: "Release Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the release should be governed"
      },
      programme: {
        title: "Is this release part of a programme?",
        help: "Select which programme this release is part of (if any)"
      }
    },
    actions: {
      cancel: "Cancel",
      createProgramme: "Create Release",
      update: "Update",
      project: "release"
    }
  },
  properties: {
    title: "Project Properties",
    fields: {
      name: {
        title: "Project Name",
        description: "Descriptive name",
      },
      identifier: {
        title: "Project Identifier",
        description: "Project number, identifier or short name"
      },
      portfolio: {
        title: "Project Portfolio",
        help: "Select the Portfolio where the project should be governed"
      },
      location: {
        title: "Location",
        help: "From where is the project managed?"
      },
      department: {
        title: "Department",
        help: "Which department or line organization owns this project?"
      },
      projectType: {
        title: "Project Type",
        help: "Different types of projects can have different types of design methods or life cycle phases"
      },
      category: {
        title: "Project Category",
        help: "What is the size or complexity level of the project?"
      },
      currency: {
        title: "Currency"
      },
      programme: {
        title: "Is this project part of a programme?",
        help: "Select which programme this project is part of (if any)"
      }
    }
  },
  background: definition.background,
  actions: {
    cancel: "Cancel",
    createProject: "Create Project",
    update: "Update",
    background: "background",
    project: "project"
  },
  clone: {
    title: "Clone project"
  }
};



// WEBPACK FOOTER //
// ./views/add/labels/english.js